import module from 'finanzas/module.js'
import template from './template.html'

function FinanzasEmpleadoprestamosCotizadorComponent (FinanzasEmpleadoprestamos, $q) {
  var $ctrl = this;
  $ctrl.$onInit = $onInit;
  $ctrl.cancelar = cancelar;
  $ctrl.calcular = calcular;

  function $onInit () {
    $ctrl.calculado = false;
    $ctrl.$promise = $q.all({
      tasas: FinanzasEmpleadoprestamos.getTasas(),
    }).then(function (resolve) {
      $ctrl.tasas = resolve.tasas.data;
    });
  }

  function cancelar () {
    $ctrl.onClose();
  }

  function calcular () {
    $ctrl.calculado = false;
    if (!$ctrl.importe_solicitado) {
      $ctrl.calculado = false;
      return;
    }
    if (!$ctrl.plazo) {
      $ctrl.calculado = false;
      return;
    }

    $ctrl.data.anios = $ctrl.plazo.meses / 12;
    $ctrl.data.tasa = $ctrl.plazo.tasa;
    var result = $ctrl.importe_solicitado * (($ctrl.plazo.tasa) / 12) / (1 - Math.pow((1 + ($ctrl.plazo.tasa) / 12), (-$ctrl.plazo.meses)));
    $ctrl.data.mensualidad = result;// (interes*$ctrl.importe_solicitado)/(1-interes2);
    $ctrl.data.total = result * $ctrl.plazo.meses;
    $ctrl.data.intereses = (result * $ctrl.plazo.meses) - $ctrl.importe_solicitado;
    $ctrl.data.prestamos_anteriores = 0;
    $ctrl.calculado = true;
  }
}

module.component('finanzasEmpleadoprestamosCotizador', {
  controller: FinanzasEmpleadoprestamosCotizadorComponent,
  template,
  bindings: {
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/_/empleadoprestamos/components/cotizador/component.js